import React, { createContext, useContext, useEffect, useState, useRef } from "react";
import server from "./Server";

const ServerContext = createContext();

export const useServer = () => useContext(ServerContext);

export const ServerProvider = ({ children }) => {
  // Server data from Server.js
  const [data, setData] = useState(server.data);

  // States currently in App.js
  const [gameId, setGameId] = useState(null);
  const gameIdRef = useRef(gameId);

  const [gameLength,setGameLength] = useState(null);
  const gameLengthRef = useRef(gameLength);

  // Sync useRefs with states
  useEffect(() => {
    gameIdRef.current = gameId;
  }, [gameId]);

    useEffect(() => {
      gameLengthRef.current = gameLength;
    }, [gameLength]);
  

  // Server data subscription
  useEffect(() => {
    const handleServerUpdate = (updatedData) => {
      setData({ ...updatedData });
    };

    server.subscribe(handleServerUpdate);

    return () => {
      server.unsubscribe(handleServerUpdate);
    };
  }, []);

  return (
    <ServerContext.Provider
      value={{
        server,
        data,
        gameState: {
          gameId,
          setGameId,
          gameIdRef,
          gameLength, 
          setGameLength, 
          gameLengthRef, 
        },
      }}
    >
      {children}
    </ServerContext.Provider>
  );
};